import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { PreparationBasic } from 'src/app/models/catalogs-model/preparation.model';
import { Subscription } from 'rxjs/internal/Subscription';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';
import { empty } from 'rxjs/internal/observable/empty';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { PreparationsService } from 'src/app/services/catalogs-services/preparations-services/preparations.service';

@Component({
  selector: 'app-catalogs-preparations-dashboard',
  templateUrl: './catalogs-preparations-dashboard.component.html',
  styleUrls: ['./catalogs-preparations-dashboard.component.scss']
})
export class CatalogsPreparationsDashboardComponent implements OnInit, OnDestroy {

  preparationsList: PreparationBasic[];
  filterOpts;
  filterKey;
  noItemsConfig;
  viewDisposition = 'grid';
  getPreparationsListSubscription: Subscription;
  searchPreparationsSubscription: Subscription;
  refreshPreparationsSubscription: Subscription;
  filterPreparationsSubscription: Subscription;
  togglePreparationsDispositionSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private snackbarService: SnackBarService,
              private cd: ChangeDetectorRef,
              private preparationsService: PreparationsService) {
                this.noItemsConfig = this.setNoItemsConfig();
              }

  ngOnInit() {
    this.setBreadcrumb();
    this.getPreparationsList();
    this.refreshPreparationsSubscription = this.preparationsService.refreshPreparationsListen().subscribe(
      (res) => {
        this.getPreparationsList();
      }
    );
    this.filterPreparationsSubscription = this.preparationsService.filterPreparationsListen().subscribe(
      (res) => {
        this.filterOpts = res;
        this.cd.detectChanges();
      }
    );
    this.searchPreparationsSubscription = this.preparationsService.searchPreparationsListen().subscribe(
      (res) => {
        this.filterKey = res;
      }
    );
    this.togglePreparationsDispositionSubscription = this.preparationsService.togglePreparationsDispositionListen().subscribe(
      (res) => {
        this.viewDisposition = res;
      }
    );
  }

  private getPreparationsList() {
    this.getPreparationsListSubscription = this.preparationsService.getPreparationsList().pipe(
      tap((o: PreparationBasic[]) => this.preparationsList = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return empty(); })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-cut', 'catalogs-page.preparations', '/catalog', [new BRoute('catalogs-page.catalog', '/catalog'), new BRoute('catalogs-page.preparations')]));
  }

  private setNoItemsConfig() {
    return {
      description: 'catalogs-page.preparations not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

  ngOnDestroy() {
    if (this.getPreparationsListSubscription) { this.getPreparationsListSubscription.unsubscribe(); }
    if (this.searchPreparationsSubscription) { this.searchPreparationsSubscription.unsubscribe(); }
    if (this.refreshPreparationsSubscription) { this.refreshPreparationsSubscription.unsubscribe(); }
    if (this.filterPreparationsSubscription) { this.filterPreparationsSubscription.unsubscribe(); }
    if (this.togglePreparationsDispositionSubscription) { this.togglePreparationsDispositionSubscription.unsubscribe(); }
  }

}
